// extracted by mini-css-extract-plugin
var _1 = "TimerCell_addButton__0SuiW";
var _2 = "TimerCell_attachment__T26Jf";
var _3 = "TimerCell_iconAddButton__iwNXL";
var _4 = "TimerCell_popupWrapper__fy7I-";
export { _1 as "addButton", _2 as "attachment", _3 as "iconAddButton", _4 as "popupWrapper" }
